import { buildColumn, EditableColumnConfig } from '~components/table-view';

/**
 * Creates column configurations for the clients with budgets table
 *
 * @param onClientClick - Callback function when a client name is clicked
 * @returns Array of column configurations for the table
 */
const columnsFactory = (onClientClick: (clientId: number) => void) => {
  const columns: EditableColumnConfig[] = [
    {
      id: 'full_name',
      header: 'Client Name',
      type: 'link',
      props: {
        meta: {
          onClick: (row: { id: number }) => onClientClick(row.id),
        },
      },
    },
    {
      id: 'budget_count',
      header: 'Budgets',
      type: 'text',
      accessorFn: (row: any) => {
        if (!row.budgets) return 0;
        return row.budgets.length || 0;
      },
    },
  ];

  return columns.map(buildColumn);
};

export default columnsFactory;
